import React, { Component } from 'react';
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input } from 'reactstrap'
import { connect } from 'react-redux';
import { fetchCUGListRequest, uploadCUGDataRequest } from "./action";
import Select from 'react-select'
import { toast } from 'react-toastify';
import { Preloading } from '../../../components/UI/Preloader/action';

class CUGUploadData extends Component {

    state = { cugData: [], selectedOption: undefined, cugfile: undefined };

    componentDidMount() {
        this.props.fetchCUGListRequest();
    }

    handleChange = selectedOption => {
        this.setState({ selectedOption: selectedOption });
    };

    uploadFile = (e) => {
        e.preventDefault();
        let file = e.target.files[0];
        if (file && file.name && (file.name.endsWith(".csv") || file.name.endsWith(".json"))) {
            this.setState({ cugfile: file });
        } else {
            this.setState({ cugfile: undefined });
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i>&nbsp;Please upload JSON and CSV Files only !
                </div>
            );
        }
        e.target = null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.cugListData !== prevProps.cugListData) {
            let cugOptionsData = [];
            this.props.cugListData && this.props.cugListData.length > 0 &&
                this.props.cugListData.map(cugobj => {
                    cugOptionsData = [
                        ...cugOptionsData, {
                            value: cugobj.id, label: cugobj.cugName
                        }
                    ]
                })
            this.setState({ cugData: cugOptionsData })
        }
        if (this.props.cugDataUploadResponse !== prevProps.cugDataUploadResponse) {
            this.props.Preloading(false);
            if (this.props.cugDataUploadResponse.status === "SUCCESS") {
                toast.success(
                    <div>
                        <i ></i>&nbsp; Data Uploaded Successfully !
                    </div>
                );
            } else {
                toast.error(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;{this.props.cugDataUploadResponse.data.message}
                    </div>
                );
            }
        }
    }

    submitDataToServer = (e) => {
        e.preventDefault();
        this.props.uploadCUGDataRequest({
            file: this.state.cugfile,
            cugId: this.state.selectedOption.value
        })
        this.props.Preloading(true);
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0 text-center">CUG Data Upload</h4>
                </div>
                <Card>
                    <CardBody >
                        <Form className="w-100" >
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={4}>CUG Name </Label>
                                <Col sm={16}>
                                    <Select
                                        value={this.state.selectedOption}
                                        onChange={this.handleChange}
                                        options={this.state.cugData} />
                                </Col>
                            </FormGroup>
                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={4}>Select CUG Data File </Label>
                                <Col sm={16}>
                                    <Input type="file" name="cug-data-file" id="cug-data-file" onChange={(e) => this.uploadFile(e)} className="btn   position-relative " style={{ borderColor: "#007bff" }} />
                                </Col>
                            </FormGroup>


                            <FormGroup style={{ marginLeft: "1rem" }} row>
                                <Label sm={14}></Label>
                                <Col sm={6}>
                                    <Button disabled={!this.state.selectedOption || !this.state.cugfile} color="primary" onClick={(e) => this.submitDataToServer(e)} > Submit Data </Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </CardBody></Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => ({
    cugListData: state.cugPortfolio.cugListData,
    cugDataUploadResponse: state.cugPortfolio.cugDataUploadResponse
})

const mapDispatchToProps = (dispatch) => ({
    fetchCUGListRequest: data => { dispatch(fetchCUGListRequest(data)) },
    uploadCUGDataRequest: data => { dispatch(uploadCUGDataRequest(data)) },
    Preloading: data => { dispatch(Preloading(data)) }
});


export default connect(mapStateToProps, mapDispatchToProps)(CUGUploadData);